import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ProjectEnvironment,
  ProjectEnvironmentRequest,
  ProjectEnvironmentUpdateRequest,
} from '../models/project-environment.model';

@Injectable({ providedIn: 'root' })
export class ProjectEnvironmentService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  /** Umgebungen des Projekts, sortiert nach Position, dann Name. */
  list(projectId: string): Observable<ProjectEnvironment[]> {
    return this.http.get<ProjectEnvironment[]>(this.listUrl(projectId));
  }

  create(projectId: string, body: ProjectEnvironmentRequest): Observable<ProjectEnvironment> {
    return this.http.post<ProjectEnvironment>(this.listUrl(projectId), body);
  }

  update(
    projectId: string,
    environmentId: string,
    body: ProjectEnvironmentUpdateRequest,
  ): Observable<ProjectEnvironment> {
    return this.http.put<ProjectEnvironment>(this.environmentUrl(projectId, environmentId), body);
  }

  remove(projectId: string, environmentId: string): Observable<void> {
    return this.http.delete<void>(this.environmentUrl(projectId, environmentId));
  }

  private listUrl(projectId: string): string {
    return `${this.base}/${projectId}/environments`;
  }

  private environmentUrl(projectId: string, environmentId: string): string {
    return `${this.listUrl(projectId)}/${encodeURIComponent(environmentId)}`;
  }
}
